class SPdpDay extends HTMLElement {
  #ac;
  #raf = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal, passive: true };
    window.addEventListener('scroll', this.#request, opts);
    window.addEventListener('resize', this.#request, opts);
    this.setAttribute('data-ready', '');
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#raf);
  }

  #request = () => {
    if (this.#raf) return;
    this.#raf = requestAnimationFrame(() => {
      this.#raf = 0;
      this.#update();
    });
  };

  #update() {
    const scenes = [...this.querySelectorAll('[data-scene]')];
    const ticks = [...this.querySelectorAll('[data-tick]')];
    if (!scenes.length) return;

    const pinned = getComputedStyle(this).getPropertyValue('--pd-pinned').trim() === '1';
    if (!pinned) {
      scenes.forEach((s) => s.removeAttribute('data-active'));
      ticks.forEach((t) => t.removeAttribute('data-on'));
      return;
    }

    const stick = this.querySelector('.pd-stick');
    const rect = this.getBoundingClientRect();
    const pin = parseFloat(getComputedStyle(stick).top) || 0;
    const travel = Math.max(1, rect.height - stick.getBoundingClientRect().height);
    const p = Math.min(1, Math.max(0, (pin - rect.top) / travel));
    const index = Math.min(scenes.length - 1, Math.floor(p * scenes.length));

    scenes.forEach((s, i) => s.toggleAttribute('data-active', i === index));
    ticks.forEach((t, i) => t.toggleAttribute('data-on', i === index));
  }
}

if (!customElements.get('s-pdp-day')) customElements.define('s-pdp-day', SPdpDay);
